module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentComponent"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v("作者")]), _vm._v(_vm._s(_vm.userInfo.showName))]), _vm._v(" "), _c('div', {
    staticClass: "reviseTime"
  }, [_c('span', [_vm._v(" 最后修改：" + _vm._s(_vm.articleContentCopy.date) + " ")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "reviseTime"
  }, [_vm._v("\n          浏览次数：" + _vm._s(_vm.articleContentCopy.view) + "\n        ")])])]), _vm._v(" "), (_vm.editShow) ? _c('div', {
    staticClass: "editInfo"
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.toEditArticle()
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("编辑")])]), _vm._v(" "), _c('div', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.toDeleteArticle()
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("删除")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.articleContentCopy.mainTitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_c('ul', _vm._l((_vm.tags), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "highlight",
      rawName: "v-highlight"
    }],
    staticClass: "markdown-content",
    attrs: {
      "id": "article"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.articleContentCopy.render)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "error-wrapper"
  }, [_c('v-Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1), _vm._v(" "), _c('v-comment', {
    staticClass: "comment"
  }), _vm._v(" "), _c('v-Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertShow),
      expression: "alertShow"
    }],
    attrs: {
      "alertInfo": _vm.alertInfo
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ac230a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article/content/content.vue
// module id = 255
// module chunks = 1